<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Our investment sweet spot</h1>
                <span class="meta"> Posted in October 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/shizen_stones_bw.png" alt="">
                </figure>

<p>We began investing in Japanese startups 7 years ago, when Japan was still considered by many to be the ultimate contrarian bet. Little did we know, but Japan’s modern digital renaissance was just beginning. Our first fund here returned a 3.5x DPI, and currently sits at a TVPI of 17x. This is not meant to be a humble brag, but rather an illustration of how incredibly and blindly lucky our timing was. As one of our early LPs dryly remarked, “Japan is the only region in the world where we can expect meaningful venture returns over the next 10 to 20 years,” and we had stumbled into it. Furthermore, we believe that this digital renaissance is still just getting started.</p>
<p>We’re deploying our third fund generation now and will soon raise a fourth, as there is a plethora of compelling opportunities in Japan right now. We value transparency with entrepreneurs, and transparency entails being clear on one’s investment scope. So here is our investment sweet spot:</p>
<h2 class="subheading">Investment sweet spot</h2>
<h3 class="subheading">Domains of interest:</h3>
<p>Software for private enterprises and healthcare organizations, deep technology innovations, climate solutions, and generally speaking digital tools that improve the way we work, live, and learn. For example, we’re fascinated by the transformative potential of decentralized infrastructures and applications these days.</p>
<h3 class="subheading">Stage of companies:</h3>
<p>Early stage startups in Japan, typically Seed and Series A stage (but we ignore labels).</p>
<p>Growth stage “scale-ups” internationally who aspire to enter the Japanese market (our partners can help establish your Japanese subsidiary if you don't have one already).</p>
<h3 class="subheading">Approach:</h3>
<p>As former entrepreneurs ourselves, we take pride in operating with a founder-friendly ethos. We are happy to co-invest with a select group of other VC funds whom we respect, but we are also not afraid to make investments on our own while others hesitate on the sidelines. We hold deep conviction that an founder’s time is their most precious asset, hence we feel that it is our duty to be decisive and agile. We often find ourselves in the position of leading deals, but only because we tend to move quickly for this reason. Sometimes we craft lawyer-baffling creative deal structures if necessary, but frankly we often prefer simply investing in straight equity, because usually this provides the best alignment between investors and founders.</p>
<p>If you’re building a company that fits the above criteria and would like to get better acquainted, even if fundraising is not in your immediate future, please feel free to reach out to us <a href="mailto:pitch@shizen.vc">here</a>. We believe that founders should pick their investors – more so than the other way around – so we would welcome the opportunity for you to get to know us too; it’s never too early.</p>
<h2 class="subheading">What’s in a name ?</h2>
<p>We’re often asked about our fund’s name, Shizen Capital. Shizen (自然) is a Japanese term rich with meaning. In the context of design, Shizen conveys the notion of incorporating elements of modernity and progress, all the while respecting the natural environment. There is an inherent tension between innovation and tradition. We believe that as investors in the emerging venture ecosystem of Japan, we must support potentially disruptive innovations while remaining mindful of the natural order of things. In our opinion, Shizen perfectly captures our philosophy.</p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
